import { render } from "./SurveyNewComponent.vue?vue&type=template&id=33e74a6c"
import script from "./SurveyNewComponent.vue?vue&type=script&lang=js"
export * from "./SurveyNewComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__